import React, { useState, useEffect } from "react";
import { SmallCard } from "../Cards/SmallCard";
import {
  get,
  post,
  put,
  deleteRequestV2,
} from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { CDBModal } from "cdbreact";
import { ModalDocManagaments } from "../Modals/ModalDocManagaments";
import { LargeCard } from "../Cards/LargeCard";
import swal from "sweetalert";
import Swal from "sweetalert2";

const usersheaders = [
  "Lote",
  "Código SAP",
  "Descripción",
  "Código Proveedor",
  "Proveedor",
  "Factura",
  "Remisión",
  "Certificado de Calidad",
  "Hoja de seguridad",
  "% de documentos",
  "Fecha de modificación",
  "Usuario",
  "/reception",
];

const defaultFormData = {
  LotNumber: "",
  CodeSap: "",
  Receipt: "",
  Remission: "",
  QualityCertificate: "",
  SafetySheet: "",
};

export const CrudDocManagaments = ({
  userName,
  permissions,
  project,
  codeSap,
}) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [action, setAction] = useState("");
  const [receptions, setReceptions] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getData = async (search, statusPage) => {
    try {
      setLoading(true);
      let response;
      if (codeSap != "" && codeSap != null && codeSap != undefined) {
        response = await get(
          `/documentsManagements?page=${statusPage}&search=${search}&CodeSap=${codeSap}&limit=${itemsPerPage}`
        );
      } else {
        response = await get(
          `/documentsManagements?page=${statusPage}&search=${search}&Nit=${project}&limit=${itemsPerPage}`
        );
      }
      if (response.answer) {
        setTotalItems(response.pagination.totalItems);
        setData(response.items);
      } else {
        console.error("Error fetching data: Unexpected response format");
        setTotalItems(0);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      swal(
        "Error",
        "Error al obtener los datos. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setTotalItems(0);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const getReception = async () => {
    try {
      const response = await get(`/receptions?Nit=${project}&List=True`);
      if (response.answer) {
        setReceptions(response.items);
      } else {
        console.error("Error fetching receptions: Unexpected response format");
        setReceptions([]);
      }
    } catch (error) {
      console.error("Error fetching receptions:", error);
      swal(
        "Error",
        "Error al obtener las recepciones. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setReceptions([]);
    }
  };

  const getDocumentsManagements = async (lotNum) => {
    try {
      const response = await get(
        `/documentsManagements?LotNumber=${lotNum.split("/*-/")[0]}&Nit=${
          lotNum.split("/*-/")[1]
        }`
      );
      if (response.answer) {
        setTotalItems(response.pagination.totalItems);
        setFormData(response.items[0]);
        toggle(6)();
      } else {
        console.error(
          "Error fetching documents management: Unexpected response format"
        );
        setTotalItems(0);
        setFormData(null);
        toggle(6)();
      }
    } catch (error) {
      console.error("Error fetching documents management:", error);
      swal(
        "Error",
        "Error al obtener el manejo de documentos. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
      setTotalItems(0);
      setFormData(null);
      toggle(6)();
    }
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const handleChange = (targets) => {
    targets.forEach((target) => {
      const { id, value } = target;
      setFormData((prevData) => ({ ...prevData, [id]: value }));
    });
  };

  const convertDataToArray = () => {
    try {
      if (!data || !Array.isArray(data)) {
        return [];
      }

      return data.map((item) => [
        item.LotNumber || "",
        item.CodeSap || "",
        item.SkuDescription || "",
        item.Nit || "",
        item.ProjectName || "",
        item.Receipt || "",
        item.Remission || "",
        item.QualityCertificate || "",
        item.SafetySheet || "",
        item.percentageOfDocuments ? item.percentageOfDocuments + "%" : "",
        item.ModificationDate || "",
        item.User || "",
      ]);
    } catch (error) {
      console.error("Error converting data to array:", error);
      return [];
    }
  };

  const handleSubmit = () => {
    const requiredFields = [
      "LotNumber",
      "CodeSap",
      "QualityCertificate",
      "Receipt",
      "Remission",
      "SafetySheet",
    ];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      swal("Error", "Por favor, rellene todos los campos", "error");
      setLoading(false);
      return false;
    }

    return true;
  };

  const saveData = async () => {
    Swal.fire({
      title: `${
        action === "create" ? "Creando" : "Actualizando"
      } Gestión Documental`,
      text: "Por favor, espere...",
      icon: "info",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    const {
      LotNumber,
      CodeSap,
      Receipt,
      Remission,
      QualityCertificate,
      SafetySheet,
      Nit,
    } = formData;
    const User = userName || "Admin";

    try {
      const response = await (action === "create" ? post : put)(
        "/documentsManagements",
        {
          LotNumber: LotNumber.toUpperCase(),
          CodeSap: CodeSap.toUpperCase(),
          Nit: Nit.toUpperCase(),
          Receipt,
          Remission,
          QualityCertificate,
          SafetySheet,
          User: User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        }
      );

      Swal.close();
      if (
        (response && response.response && response.response.status !== 200) ||
        !response.answer
      ) {
        swal(
          "Error",
          `No se pudo ${
            action === "create" ? "crear" : "actualizar"
          } la documentación. Por favor, revise la información (Puede deberse, a que ya se tiene el LOTE registrado).`,
          "error"
        );
      } else if (response.answer) {
        toggle(6)();
        swal(
          `Documentación ${action === "create" ? "creada" : "actualizada"}`,
          `La documentación. se ${
            action === "create" ? "creó" : "actualizó"
          } correctamente.`,
          "success"
        );
      }

      getData("", 1);
    } catch (error) {
      Swal.close();
      console.error(
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la documentación:`,
        error
      );
    }
  };

  const deleteQuality = async () => {
    try {
      const {
        LotNumber,
        CodeSap,
        Receipt,
        Remission,
        QualityCertificate,
        SafetySheet,
        Nit,
      } = formData;
      const User = userName || "Admin";

      const body = JSON.stringify({
        CodeSap,
        LotNumber,
        Nit,
        Receipt,
        Remission,
        QualityCertificate,
        SafetySheet,
        User,
      });

      const confirmDelete = await Swal.fire({
        title: "Confirmar Eliminación de la Gestión Documental",
        text: "Esta acción eliminará de manera permanente la Gestión Documental seleccionada, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#146284",
        cancelButtonColor: "#EF4444",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (confirmDelete.isConfirmed) {
        Swal.fire({
          title: "Eliminando Gestión Documental",
          text: "Por favor, espere...",
          icon: "info",
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        await deleteRequestV2("documentsManagements", body, true);

        Swal.close();

        toggle(6)();
        getData("", 1);
      }
    } catch (error) {
      console.error("Error deleting document management:", error);
      swal(
        "Error",
        "Error al eliminar la Gestión Documental. Por favor, inténtelo de nuevo más tarde.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "create":
        if (permissions["Crear"]) {
          getReception();
          setAction("create");
          setFormData(defaultFormData);
          toggle(6)();
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear una gestión documental",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "edit":
        if (permissions["Editar"]) {
          setAction("edit");
          getReception();
          getDocumentsManagements(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para editar una gestión documental",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "delete":
        if (permissions["Eliminar"]) {
          deleteQuality(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para borrar una gestión documental",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "refresh":
        getData("", page);
        break;
      case "closeModal":
        toggle(6)();
        break;
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          saveData();
        }
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name="Gestión documental"
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPressedButton={setPressedButton}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setSearch={setSearch}
        cState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalDocManagaments
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          receptions={receptions}
          setFormData={setFormData}
        />
      </CDBModal>
    </>
  );
};
